import React from 'react';
import CyclicFooter from '../../ui-components/Banners/CyclicFooter';

import Component from '../../ui-components/Component';
import Page from '../../ui-components/Page';
import HelpFragment from '../../ui-components/Page/components/Help';
import { makeStyle } from '../../utils';
import { withTranslations } from '../../HoCs';
import { hmsSelfOnboardingEnabled } from '../../config/countryConfig';
import { forceLogout } from '../../services/Network';

class Help extends Component {

    styles = styles;
    translation_key = 'help_translations';
    
    componentDidMount = () => hmsSelfOnboardingEnabled() && forceLogout();
    
    render = () => <Page title={this.gc('Help')} contentStyles={{ position: 'relative' }} renderFooter={() => <CyclicFooter style={this.gs('footer')} />}>
        <HelpFragment style={{ paddingBottom: 200 }} />
    </Page>;

}

const styles = {

    footer: makeStyle({ width: '100%', zIndex: 100 }),

}

export default withTranslations(Help);
